import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BasicApiResponseModel, Core2Config } from '../shared';
import { CpCommerceFormFieldSetContainerModel } from '../../../../../models/aggregates/website-form/cpcommerce-form-field-set-container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CpCommerceFormFieldSetService extends BaseApiPublicLoginTemplateService<CpCommerceFormFieldSetContainerModel,CpCommerceFormFieldSetContainerModel,CpCommerceFormFieldSetContainerModel> {

  static readonly CP_COMMERCE_FORM_FIELD_SET_PATH = 'form-field-sets/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetService.CP_COMMERCE_FORM_FIELD_SET_PATH  + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetService.CP_COMMERCE_FORM_FIELD_SET_PATH  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetService.CP_COMMERCE_FORM_FIELD_SET_PATH  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetService.CP_COMMERCE_FORM_FIELD_SET_PATH  + BaseApiTemplateService.PUBLIC_EP;
  }

  getByGuidPublic(guid: string,  visa: ApiVisa): Observable<BasicApiResponseModel<CpCommerceFormFieldSetContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetService.CP_COMMERCE_FORM_FIELD_SET_PATH + 'public-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetService.CP_COMMERCE_FORM_FIELD_SET_PATH + 'public-ep';
    }
    return this.httpClient.get<BasicApiResponseModel<CpCommerceFormFieldSetContainerModel>>(url + '/' + guid, this.getHttpHeader(visa));
  }
}

